import React, { Component } from "react";

import ContactForm from "../ContactForm";

class ContactPage extends Component {
    render() {
        return (
            <ContactForm />
        )
    }
}

export default ContactPage;